import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import './header-search.scss'
import { connect } from 'react-redux'
import { pushClearSearch, pushSearchOpen } from '../../../../helpers/gtm'
import {isDesktop} from '../../../../helpers/browser'
import { HOMEPAGE_VIEW } from '../../constants'
import cn from "classnames";

class HeaderSearch extends PureComponent {

  constructor(props) {
    super(props);
    this.searchWrapRef = React.createRef();
  }
  onClearSearchHandler = (e) => {
    e.stopPropagation()
    this.keywordRef.value = ''
    pushClearSearch()
  }

  getKeyword = () => {
    const { keyword, holdKeyword } = this.props
    return holdKeyword || keyword
  }

  handleSearchClick = (e) => {
    const { onClick } = this.props
    onClick(e)
  }

  handleSearchSubmit = (e) => {
    const {
      onClick,
      onDesktopSubmit,
      browser,
    } = this.props
    const inputValue = this.getKeyword()
    if (inputValue && isDesktop(browser)) {
      onDesktopSubmit(e)
    } else {
      onClick(e)
    }
  }

  openSearchClick = (e) => {
    const { onClick } = this.props
    pushSearchOpen()
    onClick(e)
  }

  checkPageScroll = () => {
    const searchBox = this.searchWrapRef.current
    const body = window.document.body;
    const searchWrap = searchBox.parentNode;
    const searchWrapInfo = searchWrap.getBoundingClientRect()
    const topOffset = searchWrapInfo.top;

    if (topOffset <= 105) {
      searchWrap.style.minHeight = searchWrapInfo.height + 'px'
      searchBox.classList.add('fix-search')
      body.classList.add('fixed-search')
    } else {
      searchBox.classList.remove('fix-search')
      body.classList.remove('fixed-search')
    }
  }

  componentDidMount() {
    const { sticky } = this.props;
    if (sticky) {
      window.addEventListener('scroll', this.checkPageScroll)
    }
  }

  render() {
    const {
      placeholder,
      searchButtonValue,
      showFilters,
      onChange,
      onKeyPress,
      clearSearch,
    } = this.props
    const renderButton = () => {
      if (!showFilters) {
        return (
          <input
            role={'button'}
            aria-label={searchButtonValue}
            className="header-search__search-button"
            type="button"
            value={searchButtonValue}
            onClick={this.handleSearchSubmit}
          />
        )
      }  else {
        return (
          <input
            className="header-search__clear"
            type="button"
            value={clearSearch}
            onClick={this.onClearSearchHandler}
          />
        )
      }
    }

    return (
      <React.Fragment>

        { showFilters ? (
            <div className="header-search" ref={this.searchWrapRef}>
              <div className="header-search__search-icon">
                <svg aria-labelledby="NEWSEARCH">
                  <use xlinkHref="#NEWSEARCH" />
                </svg>
              </div>
              <input
                ref={(keyword) => { this.keywordRef = keyword }}
                className="header-search__search-text"
                id="header-search-field"
                placeholder={placeholder}
                type="text"
                name="keyword"
                value={showFilters ? this.getKeyword() : ''}
                onClick={this.openSearchClick}
                readOnly
              />
              <label htmlFor="header-search-field" className="visually-hidden">
                {placeholder}
              </label>
              { renderButton() }
            </div>

          ) :
          (
            <div className={'header-search__wrapper simple-search'}
                 ref={this.searchWrapRef}
                 onClick={this.handleSearchClick}>
              <div className="header-search">
                <div className="header-search__search-icon">
                  <svg aria-labelledby="NEWSEARCH">
                    <use xlinkHref="#NEWSEARCH" />
                  </svg>
                </div>
                <input
                  ref={(keyword) => { this.keywordRef = keyword }}
                  className="header-search__search-text"
                  id="header-search-field"
                  placeholder={placeholder}
                  type="text"
                  name="keyword"
                  value={this.getKeyword()}
                  onClick={this.openSearchClick}
                  onChange={onChange}
                  onKeyPress={onKeyPress}
                  autoComplete="off"
                />
                <label htmlFor="header-search-field" className="visually-hidden">
                  {placeholder}
                </label>
              </div>
              { renderButton() }
            </div>
          )}
      </React.Fragment>
    )
  }
}


HeaderSearch.defaultProps = {
  placeholder: '',
  holdKeyword: '',
  pageView: '',
}

HeaderSearch.propTypes = {
  placeholder: PropTypes.string,
  searchButtonValue: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  showFilters: PropTypes.bool.isRequired,
  clearSearch: PropTypes.string.isRequired,
  keyword: PropTypes.string.isRequired,
  pageView: PropTypes.string,
  holdKeyword: PropTypes.string,
}

const mapStateToProps = ({
  main: { holdKeyword, searchUrlHolder },
  browser,
}) => ({
  holdKeyword,
  searchUrlHolder,
  browser,
})
export default connect(mapStateToProps)(HeaderSearch)
